export default __webpack_public_path__ + "static/0050-15c49103cd0f1e32a4e2a3ad5adfc0b0.png";